// Texty spec chipů na kartě výpisu (specChips.js). `params` NEJSOU jen popisky:
// modul je páruje (přes slug) s názvy INFO parametrů z vyhledávacího indexu,
// tedy s daty Shoptetu v jazyce shopu. Výjimka: `postroj`, `priklep`, `vyska`
// jsou kurátorské štítky za `|` (UI text, nepárují se).
export default {
  /** hodnota ano/ne řádku („Postroj — Ano") */
  yes: 'Ano',
  /** ano/ne v hodnotě parametru z indexu (malými písmeny, čte se jako data) */
  boolYes: 'ano',
  boolNo: 'ne',
  params: {
    prikon: 'Příkon',
    maxPrutok: 'Max. průtok',
    maxVytlak: 'Max. výtlak',
    vykonMotoru: 'Výkon motoru',
    prikonVykon: 'Příkon / výkon',
    maxSaciHloubka: 'Max. sací hloubka',
    delkaListy: 'Délka lišty',
    napeti: 'Napětí',
    kapacitaBaterie: 'Kapacita baterie',
    napetiBaterie: 'Napětí baterie',
    krouticiMoment: 'Krouticí moment',
    prumerKotouce: 'Průměr kotouče',
    otackyNaprazdno: 'Otáčky naprázdno',
    vykon: 'Výkon',
    zdvihovyObjemMotoru: 'Zdvihový objem motoru',
    postroj: 'Postroj',
    priklep: 'Příklep',
    upinani: 'Upínání',
    energieUderu: 'Energie úderu',
    hmotnost: 'Hmotnost',
    prumeryNastavcu: 'Průměry nástavců',
    maxTeplota: 'Max. teplota',
    svarovaciProud: 'Svařovací proud',
    prumerElektrody: 'Průměr elektrody',
    delkaKabelu: 'Délka kabelu',
    pocetZasuvek: 'Počet zásuvek',
    prurezVodice: 'Průřez vodiče',
    materialBubnu: 'Materiál bubnu',
    pocetNastrojuVSade: 'Počet nástrojů v sadě',
    pocetBaterii: 'Počet baterií',
    nosnost: 'Nosnost',
    minVyska: 'Min. výška',
    objemNadobky: 'Objem nádobky',
    tahMagnetu: 'Tah magnetu',
    zavitOka: 'Závit oka',
    taznaSilaNosnost: 'Tažná síla / nosnost',
    delka: 'Délka',
    barva: 'Barva',
    vyska: 'Výška',
    pracovniSirka: 'Pracovní šířka',
    pracovniHloubka: 'Pracovní hloubka',
    objemNadrze: 'Objem nádrže',
    prumerVentilatoru: 'Průměr ventilátoru',
    pocetRychlosti: 'Počet rychlostí',
    objemNadoby: 'Objem nádoby',
    saciVykon: 'Sací výkon',
    rozmery: 'Rozměry',
    objemVody: 'Objem vody',
    material: 'Materiál',
    teplotniRozsah: 'Teplotní rozsah',
    pocetPlotynek: 'Počet plotýnek',
    objemKartuse: 'Objem kartuše',
    nabijeciNapeti: 'Nabíjecí napětí',
    nabijeciProud: 'Nabíjecí proud',
    rozsahKapacityBaterie: 'Rozsah kapacity baterie',
    maximalniNosnost: 'Maximální nosnost',
  },
};
